/**
 * How many cards are in a cell's set, as `aria-setsize` means it, and the number the
 * cell's own accessible name states.
 *
 * The set is every card the cell has, not every card it has loaded. Those are different
 * numbers on a board that pages, and the loaded one is exactly the number the attribute
 * exists to replace: it is what a browser would have counted off the page anyway, and it
 * changes under a reader every time another page arrives.
 *
 * So the count the caller stated wins, floored at what is loaded, because a count from a
 * server can be stale and a set smaller than the cards already in it is not a set. `-1`
 * is ARIA's way of saying the total is not known, which is the honest answer for a cell
 * that says it has more and never said how many.
 *
 * Shared rather than worked out where it is needed, so the number in a cell's name, the
 * number on the cards inside it and the number a described card reports cannot drift
 * apart.
 */
export function cardSetSize({
  totalCount,
  hasMoreItems,
  loaded,
}: {
  totalCount: number | undefined
  hasMoreItems: boolean
  loaded: number
}): number {
  if (totalCount !== undefined) return Math.max(totalCount, loaded)

  return hasMoreItems ? -1 : loaded
}
